import { Card, Typography } from 'antd';
import React from 'react';
import { FcPlus } from 'react-icons/all';
import { Link } from 'gatsby';
import { inMemoryAuth } from '../../auth/in-memory-auth';

const { Title } = Typography;

export const CreateAccountCard = () => {
  if (inMemoryAuth.token) {
    return null;
  }

  return (
    <Card hoverable bordered={false}>
      <Link to="/user/auth/">
        <Card.Meta
          avatar={<FcPlus />}
          title={<Title level={4}>Create a free account</Title>}
          description="Easily send requests and inquiries. Save, Create supplier lists, & more."
        />
      </Link>
    </Card>
  );
};
